// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { safeLocalStorage } from '@/lib/safeStorage';

const SUPABASE_URL = "https://odeztzpwbfockqwesxeu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9kZXp0enB3YmZvY2txd2VzeGV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg3NTE1MTMsImV4cCI6MjA4NDMyNzUxM30.hA6XfcG6IFMrGgoPFc-tcuy5l9RcQlkE4JE9jI7f2oA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeLocalStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
